"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RIGHT_IMAGE_PARAMS = exports.RIGHT_IMAGE_DESKTOP_WIDTH = exports.RIGHT_IMAGE_DESKTOP_HEIGHT = exports.LEFT_IMAGE_PARAMS = exports.LEFT_IMAGE_DESKTOP_WIDTH = exports.LEFT_IMAGE_DESKTOP_HEIGHT = void 0;
var _utils = require("../../utils");
const LEFT_IMAGE_DESKTOP_WIDTH = exports.LEFT_IMAGE_DESKTOP_WIDTH = 360;
const LEFT_IMAGE_DESKTOP_HEIGHT = exports.LEFT_IMAGE_DESKTOP_HEIGHT = 460;
const LEFT_IMAGE_PARAMS = exports.LEFT_IMAGE_PARAMS = (0, _utils.getImageParamsAndSizes)({
    desktopWidth: LEFT_IMAGE_DESKTOP_WIDTH,
    mobileWidth: LEFT_IMAGE_DESKTOP_WIDTH
});
const RIGHT_IMAGE_DESKTOP_WIDTH = exports.RIGHT_IMAGE_DESKTOP_WIDTH = 490;
const RIGHT_IMAGE_DESKTOP_HEIGHT = exports.RIGHT_IMAGE_DESKTOP_HEIGHT = 290;
const RIGHT_IMAGE_PARAMS = exports.RIGHT_IMAGE_PARAMS = (0, _utils.getImageParamsAndSizes)({
    desktopWidth: RIGHT_IMAGE_DESKTOP_WIDTH,
    mobileWidth: RIGHT_IMAGE_DESKTOP_WIDTH
});
